export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-volume-25efe29ffdcf21638c9980e83a137ef2.svg";